<cdp-single-select
    [bindLabel]="bindLabel"
    [controlName]="controlName"
    [clearable]="true"
    [placeholder]="placeholder ? placeholder : ''"
    [tooltip]="tooltip"
    [items]="selectOptions"
    [selection]="selection"
    (selectionChange)="onChange($event)"
>
</cdp-single-select>
